export default __webpack_public_path__ + "static/media/logo_lhtheater_18_rot.0e428480.png";